import * as React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Icon, Pill, Text, getIcon } from '@quality24/design-system';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import styles from './ActionCard.module.scss';

export interface Props {
  className?: string;
  icon?: string;
  disabled?: boolean;
  /** Whether there is an action already in progress for this card. */
  inProgress?: boolean;
  title: string;
  onSelect: () => void;
  direction?: 'column' | 'row';
}

const ActionCard: React.FunctionComponent<Props> = ({
  className,
  icon = 'FaQuestion',
  disabled = false,
  inProgress = false,
  title,
  onSelect,
  direction = 'column',
}) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={classNames(className, styles.wrapper, {
        disabled,
        [`card-${direction}`]: direction,
      })}
      onClick={!disabled ? onSelect : undefined}
    >
      <Icon icon={getIcon(icon) || faQuestionCircle} color="white" />
      <div>
        <Text weight="semiBold" color="white">
          {title}
        </Text>
        {inProgress && <Pill value={t('common.inProgress')} />}
      </div>
    </button>
  );
};

export default ActionCard;
